import { useEffect } from "react";
import "./App.css";
import {
  Grid,
  Typography,
  Box,
  IconButton,
  Link,
  Card,
  CardActionArea,
  Stack,
  Button,
} from "@mui/material";
import Instagram from "@mui/icons-material/Instagram";
import logo from "./images/logoTransparent.avif";
import ebay from "./images/ebay.svg";
import ebay_gold from "./images/ebay_gold.svg";
import discogs from "./images/discogs.svg";
import discogs_gold from "./images/discogs_gold.svg";
import { AttachMoney, Facebook, Person, Photo } from "@mui/icons-material";
import DayHours from "./DayHours";
import spinningRecord from "./images/spinning-record.gif";

export const gold = "#fabe06";
export const black = "#101207";
export const sellButtonColor = "#3b7e2b";

const date = new Date();
const day = date.getDay();

const HomeView = ({ setCurrentView }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box bgcolor={black} padding={2} textAlign="center">
        <Typography variant="h4" fontFamily="Goblin One" color={gold}>
          Welcome to
        </Typography>
        <Typography variant="h2" fontFamily="Smokum" color={gold}>
          Railroad Records
        </Typography>
        <Box textAlign="center" marginTop="10px">
          <Link
            target="_blank"
            href="https://www.facebook.com/profile.php?id=61577181733262"
          >
            <IconButton>
              <Facebook style={{ color: `${gold}` }} fontSize="large" />
            </IconButton>
          </Link>

          <Link
            target="_blank"
            href="https://www.instagram.com/railroadrecordspa/"
          >
            <IconButton>
              <Instagram style={{ color: `${gold}` }} fontSize="large" />
            </IconButton>
          </Link>

          <Link target="_blank" href="https://www.ebay.com/usr/railroadrecords">
            <IconButton>
              <img src={ebay_gold} alt="Ebay Logo" height="35px" />
            </IconButton>
          </Link>

          <Link
            target="_blank"
            href="https://www.discogs.com/user/railroadrecordspa"
          >
            <IconButton>
              <img src={discogs_gold} alt="Discogs Logo" height="35px" />
            </IconButton>
          </Link>
        </Box>
      </Box>

      <Grid container direction="column" alignItems="center">
        <img src={logo} alt="Logo" height="400px" />
      </Grid>

      <Box paddingTop="10px">
        <Typography textAlign="center" fontFamily="Goblin One" color={black}>
          335 Vine Street - Bethlehem, PA
        </Typography>
        <Typography
          textAlign="center"
          padding={1}
          fontFamily="Goblin One"
          color={black}
          sx={{
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          <a
            href="tel:267-730-4449"
            style={{ color: `${black}`, textDecoration: "none" }}
          >
            (267) 730-4449
          </a>
        </Typography>
        <Typography
          textAlign="center"
          fontFamily="Goblin One"
          color={black}
          sx={{
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          <a
            href="mailto:railroadrecordsllc@gmail.com"
            style={{ color: `${black}`, textDecoration: "none" }}
          >
            railroadrecordsllc@gmail.com
          </a>
        </Typography>

        <Typography
          marginTop="35px"
          textAlign="center"
          variant="h4"
          fontFamily="Goblin One"
          color={black}
        >
          Hours
        </Typography>

        <Grid container justifyContent="center">
          <Stack>
            <DayHours day="Monday" hours="CLOSED" highlighted={day === 1} />
            <DayHours
              day="Tuesday"
              hours="11 AM - 6 PM"
              highlighted={day === 2}
            />
            <DayHours day="Wednesday" hours="CLOSED" highlighted={day === 3} />
            <DayHours day="Thursday" hours="CLOSED" highlighted={day === 4} />
            <DayHours
              day="Friday"
              hours="11 AM - 6 PM"
              highlighted={day === 5}
            />
            <DayHours
              day="Saturday"
              hours="11 AM - 6 PM"
              highlighted={day === 6}
            />
            <DayHours
              day="Sunday"
              hours="11 AM - 6 PM"
              highlighted={day === 0}
            />
          </Stack>
        </Grid>

        <Box display="flex" justifyContent="center" marginTop="50px">
          <Stack direction="column" spacing={3}>
            <Button
              target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLSdA1QzLkdYvmrZIGSwCJkJRvPKw_nw7JtajtDhkqG19F0VvqQ/viewform?usp=dialog"
              startIcon={<AttachMoney />}
              endIcon={<AttachMoney />}
              sx={{
                backgroundColor: `${sellButtonColor}`,
                color: `${gold}`,
                fontFamily: "Goblin One",
                fontSize: "24px",
                padding: "12px",
              }}
              textAlign="center"
            >
              Sell to Us!
            </Button>
          </Stack>
        </Box>

        <Box display="flex" justifyContent="center" marginTop="50px">
          <Stack direction="column" spacing={3}>
            <Button
              startIcon={<Photo />}
              sx={{
                backgroundColor: `${black}`,
                color: `${gold}`,
                fontFamily: "Goblin One",
              }}
              textAlign="center"
              onClick={() => {
                setCurrentView("gallery");
              }}
            >
              View Photos
            </Button>
            <Button
              startIcon={<Person />}
              sx={{
                backgroundColor: `${black}`,
                color: `${gold}`,
                fontFamily: "Goblin One",
              }}
              textAlign="center"
              onClick={() => {
                setCurrentView("asa");
              }}
            >
              About the Owner
            </Button>
          </Stack>
        </Box>

        <Typography
          marginTop="50px"
          textAlign="center"
          variant="h4"
          fontFamily="Goblin One"
          color={black}
        >
          In the News
        </Typography>

        <Grid container justifyContent="center">
          <Card style={{ padding: 10, backgroundColor: `${black}` }}>
            <CardActionArea
              target="_blank"
              href="https://thebrownandwhite.com/2025/09/10/railroad-records-spins-a-new-community-hub-on-south-side/"
            >
              <img
                src="https://thebrownandwhite.com/wp-content/uploads/2025/09/LIFESTYLEPHAMRECORDSTORE090525_ROWAN002.jpg"
                alt="Vinyl Records"
                height="250px"
              />
              <Typography
                textAlign="center"
                fontFamily="Goblin One"
                color={gold}
              >
                The Brown and White
              </Typography>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid container justifyContent="center" marginTop="25px">
          <Card style={{ padding: 10, backgroundColor: `${black}` }}>
            <CardActionArea
              target="_blank"
              href="https://www.wfmz.com/news/area/lehighvalley/super-excited-new-bethlehem-record-store-looks-to-open-in-time-for-musikfest/article_b118a4ec-a7f7-43e9-bc0a-cb126ec4a443.html"
            >
              <img
                src="https://bloximages.newyork1.vip.townnews.com/wfmz.com/content/tncms/assets/v3/editorial/8/91/891d2ec1-0a57-4378-984d-33eb65f52d9f/685d78c69b05f.image.jpg?resize=1200%2C651"
                alt="Vinyl Records"
                height="200px"
              />
              <Typography
                textAlign="center"
                fontFamily="Goblin One"
                color={gold}
              >
                WFMZ
              </Typography>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid container justifyContent="center" marginTop="25px">
          <Card style={{ padding: 10, backgroundColor: `${black}` }}>
            <CardActionArea
              target="_blank"
              href="https://lehighdaily.com/after-double-deckers-closure-this-history-grad-is-filling-the-lehigh-valleys-vinyl-void/"
            >
              <img
                src="https://lehighdaily.com/wp-content/uploads/2025/06/Screen-Shot-2025-06-24-at-3.07.18-PM-1376x774.png"
                alt="Storefront"
                height="200px"
              />
              <Typography
                textAlign="center"
                fontFamily="Goblin One"
                color={gold}
              >
                Lehigh Daily
              </Typography>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid container justifyContent="center" marginTop="25px">
          <Card style={{ padding: 10, backgroundColor: `${black}` }}>
            <CardActionArea
              target="_blank"
              href="https://www.mcall.com/2025/06/30/railroad-records-bethlehem-summer-opening-vinyl-books-clothes-cds-double-decker-allentown/?fbclid=PAZXh0bgNhZW0CMTEAAad2L17KKZ0ioKP6m3NjN20lvHDA3wFYjz4KubIASI2omiOfqarR_LTC40smbw_aem_i5MnZnlSM34MX3T1frGu0Q"
            >
              <img
                src="https://www.mcall.com/wp-content/uploads/2025/06/TMC-L-RailroadRecords-01-1.jpg"
                alt="Country Vinyl Records"
                height="330px"
              />
              <Typography
                textAlign="center"
                fontFamily="Goblin One"
                color={gold}
              >
                The Morning Call
              </Typography>
            </CardActionArea>
          </Card>
        </Grid>

        <Box textAlign="center" margin="50px 0px">
          <Link
            target="_blank"
            href="https://www.facebook.com/profile.php?id=61577181733262"
          >
            <IconButton>
              <Facebook style={{ color: "#101207" }} fontSize="large" />
            </IconButton>
          </Link>

          <Link
            target="_blank"
            href="https://www.instagram.com/railroadrecordspa/"
          >
            <IconButton>
              <Instagram style={{ color: "#101207" }} fontSize="large" />
            </IconButton>
          </Link>

          <Link target="_blank" href="https://www.ebay.com/usr/railroadrecords">
            <IconButton>
              <img src={ebay} alt="Ebay Logo" height="35px" />
            </IconButton>
          </Link>

          <Link
            target="_blank"
            href="https://www.discogs.com/user/railroadrecordspa"
          >
            <IconButton>
              <img src={discogs} alt="Discogs Logo" height="35px" />
            </IconButton>
          </Link>
        </Box>

        <img
          src={spinningRecord}
          alt="Spinning Vinyl Record"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "-1",
            opacity: "3%",
            width: "25%",
            minWidth: "450px",
          }}
        />
      </Box>
    </>
  );
};

export default HomeView;
